import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import bindCoreUI from "@intelingu/core/components/provider/bindCoreUI";
import bindField from "@intelingu/core/components/form/bindField";

export interface FieldProps {
    form?;
}

@bindCoreUI
@bindField
@observer export class FormErrorMessage extends Component<FieldProps, any> {

    render() {
        const { form } = this.props;

        return <>
            { form.store.errors.length > 0 && (
                <div className={'alert alert-danger mb-2'}>One or more fields are missing. Please check above.</div>
            ) }
        </>;
    }

}
